module.exports = "<span translate>\n    <ng-content></ng-content>\n</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-label/ui-label.html
// module id = 1111
// module chunks = 3